// extracted by mini-css-extract-plugin
export default {"container":"styles_container__LUuOE","header":"styles_header__kuqwJ","body":"styles_body__k2S97"};